import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';

export interface ICustomerEmailMapping {
  _id: ObjectID;
  generatedEmail: string;
  originalEmail: string;
  updatedAt: Date;
  createdAt: Date;
}

export interface ICustomerEmailMappingDocument extends mongoose.Document, ICustomerEmailMapping {
  _id: ObjectID;
}

const schema = new Schema(
  {
    generatedEmail: {
      type: String,
      required: true,
    },
    originalEmail: {
      type: String,
      required: true,
    },
  },
  { timestamps: true },
);

schema.index({ generatedEmail: 1 }, { unique: true });
schema.index({ originalEmail: 1 }, { unique: true });

export default schema;
